import loadingPanelImage from 'Assets/images/empy-states/empty-conversations-chat.png';
import * as React from 'react';
import { EmptyState } from '~/lib/ui/emptyState';

interface LoadingPanelIllustrationProps {
  className?: string;
  alt?: string;
}

const EmptyConversationImage: React.FC<LoadingPanelIllustrationProps> = ({
  className = 'w-full max-w-[328px] h-auto',
  alt = 'Loading',
}) => {
  return <img src={loadingPanelImage} alt={alt} className={className} />;
};

/**
 * Empty state component displayed when there are no conversations to show in the chat interface.
 *
 * This component provides a user-friendly message and illustration to guide users on how to
 * start their first conversation when the conversation list is empty.
 *
 * @returns JSX element containing an empty state with title, description, and illustration
 */
export const ChatConversationsEmptyState = () => {
  return (
    <div data-testid="chat-conversations-empty-state" className="flex flex-col items-center justify-center h-full">
      <EmptyState
        title="Looks quiet here"
        description="Use the top-left button and start talking!"
        illustration={<EmptyConversationImage />}
      />
    </div>
  );
};
